import { WarehouseSkuUsageStatus } from '../enums/warehouse-sku-usage-status';
import { Nillable } from '@web/utils';
import { WarehouseSkuUsageReceipt } from './warehouse-sku-usage-receipt';
import { WarehouseSkuUsageProduct } from './warehouse-sku-usage-product';

export class WarehouseSkuUsage {
  public constructor(
    private readonly data: {
      status: WarehouseSkuUsageStatus;
      product?: Nillable<WarehouseSkuUsageProduct>;
      receipts?: WarehouseSkuUsageReceipt[];
    },
  ) {}

  public get status(): WarehouseSkuUsageStatus {
    return this.data.status;
  }

  public get product(): Nillable<WarehouseSkuUsageProduct> {
    return this.data.product;
  }

  public get receipts(): Nillable<WarehouseSkuUsageReceipt[]> {
    return this.data.receipts;
  }
}
